import CampaignNote from '@/services/rest/bemob/campaign-note';
import { StatusEnum } from '@/services/models/Enums';

export class CampaignNoteApi {
  api: CampaignNote = new CampaignNote();

  loading: boolean = false;
  error: boolean = false;

  create(campaignId: string, payload: Bemob.Note) {
    this.loading = true;

    return this.api.postCreate(campaignId, payload).then((payload: Bemob.RawResponse<Bemob.Note>) => {
      return payload.data.payload;
    }).finally(()=>{
      this.loading = false;
    });
  }

  getNotes(campaignId: string, payload: Bemob.NoteFilter) {
    this.loading = true;

    return this.api.getList(campaignId, payload).then((payload: Bemob.RawResponse<Bemob.Note[]>) => {
      return payload.data.payload;
    }).finally(()=>{
      this.loading = false;
    });
  }

  update(campaignId: string, id: string, payload: Bemob.Note) {
    this.loading = true;
    
    return this.api.putUpdate(campaignId, id, payload).then((payload: Bemob.RawResponse<Bemob.Note>) => {
      return payload.data.payload;
    }).finally(()=>{
      this.loading = false;
    });
  }

  delete(campaignId: string,payload: Bemob.Note) {
    this.loading = true;

    let note: Bemob.Note = {
      ...payload,
      status: StatusEnum.archived,
    };

    return this.api.putUpdate(campaignId, note.id, note).then((payload: Bemob.RawResponse<Bemob.Note>) => {
      return payload.data.payload;
    }).finally(()=>{
      this.loading = false;
    });
  }
}

export default new CampaignNoteApi();